import { ICompany, IDiffBadge } from "@/models";
import { Vue, Component, Prop } from "vue-property-decorator";
import { DiffBadgeNature } from "@/enums";


@Component
export default class CompanyDiffBadge extends Vue {
    @Prop({ default: null })
    public readonly scopeObject: IDiffBadge<ICompany>;

    get badge(): unknown {
        if(this.scopeObject.nature == DiffBadgeNature.Added) {
            return {
                color: "green darken-3 font-weight-black",
                text: "+"
            };
        }
        else if(this.scopeObject.nature == DiffBadgeNature.Removed){
            return {
                color: "red darken-1 font-weight-black",
                text: "-"
            };
        }
        else {
            return null;
        }
    }

    get isNew(): boolean{
        return this.scopeObject.nature === DiffBadgeNature.New;
    }
}
